import React from 'react'

function Browse() {
  return (
    <div>
      <h1>bROSER</h1>
    </div>
  )
}

export default Browse
